module.exports = __webpack_public_path__ + "img/ts16.9ee4fdca.png";